import { AuthPayload } from "@/interfaces/ui.interface"

export default {
  setTestimonias(state: any, payload: any) {
    state.TestimonialsList = payload
    state.totalItems = payload?.data.total
    state.page = payload?.data.page
    state.limit = payload?.data.limit
  },
  addTestimonialsItem(state: any, payload: AuthPayload) {
    state.statusInsertTestimonials = payload
  },
  editTestimonialsItem(state: any, payload: AuthPayload) {
    state.statusUpdateTestimonials = payload
  },
  delTestimonialsItem(state: any, payload: AuthPayload) {
    state.statusDelTestimonials = payload
  }
}